<template>
  <Row>
    <Col span="24">
      <Card shadow style="width: 100%; height: 480px">
        <div style="width: 98%; left: 10px; top: 10px; z-index: 9">
          <Row class="indexCol" :gutter="16">
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('statistics') + $t('type')"
                size="small"
                v-model="dateType"
                @on-change="selChange"
                :clearable="false"
                filterable
                filter-by-label
              >
                <Option
                  v-for="cou in dateTypeList"
                  :key="cou.value"
                  :value="cou.value"
                  :label="$t(cou.label)"
                ></Option>
              </Select>
            </Col>
            <Col span="3">
              <DatePicker
                @on-change="shipmentChangeDate"
                v-model="shipmentDate"
                :options="{
                  disabledDate(date) {
                    return date && date.valueOf() >= new Date();
                  },
                }"
                :clearable="false"
                type="daterange"
                :placeholder="$t('select') + $t('statistics') + $t('date')"
                size="small"
                style="min-width: 200px"
              ></DatePicker>
            </Col>
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('fangdan')"
                size="small"
                v-model="cod_type"
                @on-change="selChange"
                clearable
                filterable
                filter-by-label
              >
                <Option value="NOR" :label="$t('Prepaid')"></Option>
                <Option value="NCND" :label="$t('ToPay')"></Option>
              </Select>
            </Col>
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('countryName')"
                size="small"
                @on-change="selChange"
                v-model="country"
                clearable
                filterable
                filter-by-label
                multiple
                :max-tag-count="1"
              >
                <Option
                  v-for="cou in countryList"
                  :key="cou.id"
                  :value="cou.code"
                  :label="cou.cn_title"
                ></Option>
              </Select>
            </Col>
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('channel_name')"
                size="small"
                v-model="transport_mode"
                @on-change="selChange"
                clearable
                filterable
                filter-by-label
              >
                <Option
                  v-for="cou in transportList"
                  :key="cou.id"
                  :value="cou.channel_code"
                  :label="cou.channel_name"
                ></Option>
              </Select>
            </Col>
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('clientName')"
                size="small"
                v-model="client_id"
                @on-change="selChange"
                clearable
                filterable
                filter-by-label
                multiple
                :max-tag-count="1"
              >
                <Option
                  v-for="cou in clientList"
                  :key="cou.id"
                  :value="cou.id"
                  :label="cou.account"
                ></Option>
              </Select>
            </Col>
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('localFaction')"
                size="small"
                v-model="delivery_agent_id"
                @on-change="selChange"
                clearable
                filterable
                filter-by-label
              >
                <Option
                  v-for="cou in deliveryList"
                  :key="cou.id"
                  :value="cou.id"
                  :label="cou.agent_name"
                ></Option>
              </Select>
            </Col>
            <Col span="3">
              <Select
                :placeholder="
                  $t('select') + $t('whether') + $t('DomesticDelivery')
                "
                size="small"
                v-model="chainOut"
                @on-change="selChange"
                clearable
                filterable
                filter-by-label
              >
                <Option
                  v-for="cou in DomesticList"
                  :key="cou.value"
                  :value="cou.value"
                  :label="$t(cou.label)"
                ></Option>
              </Select>
            </Col>
            <!-- style="margin-top:10px" -->
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('analysis') + $t('type')"
                size="small"
                v-model="type"
                @on-change="selChange"
                :clearable="false"
                filterable
                filter-by-label
              >
                <Option
                  v-for="cou in typeList"
                  :key="cou.value"
                  :value="cou.value"
                  :label="$t(cou.label)"
                ></Option>
              </Select>
            </Col>
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('is_goods')"
                size="small"
                v-model="headerType"
                @on-change="selChange"
                clearable
                filterable
                filter-by-label
              >
                <Option
                  v-for="cou in headerList"
                  :key="cou.value"
                  :value="cou.value"
                  :label="$t(cou.label)"
                ></Option>
              </Select>
            </Col>
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('serviceName')"
                size="small"
                v-model="customer_service_id"
                @on-change="selChange"
                clearable
                filterable
                filter-by-label
              >
                <Option
                  v-for="cou in serviceList"
                  :key="cou.account"
                  :value="cou.id"
                  :label="$t(cou.account)"
                ></Option>
              </Select>
            </Col>
            <Col span="3">
              <Select
                :placeholder="$t('select') + $t('delService')"
                size="small"
                v-model="dbl_customer_service_id"
                @on-change="selChange"
                clearable
                filterable
                filter-by-label
              >
                <Option
                  v-for="cou in dblSerList"
                  :key="cou.account"
                  :value="cou.id"
                  :label="$t(cou.account)"
                ></Option>
              </Select>
            </Col>
            <Col span="2">
              <Button
                @click="getAgingFun"
                type="primary"
                icon="ios-search"
                size="small"
                >{{ $t("querySearch") }}</Button
              >
            </Col>
          </Row>
        </div>
        <chart-line :option="option" style="width: 100%; height: 370px" />
      </Card>
    </Col>
  </Row>
</template>

<script>
import { ChartLine } from "_c/charts";
import format from "@/utils/format.js";
import { getAssignDate } from "@/libs/tools.js";
import { getHeadTime } from "@/api/user";
import { getCountry } from "@/api/system/country";
// import { getChannel } from "@/api/tracker/channel";
import { getAllClient } from "@/api/user/client";
// import { getAgent } from "@/api/tracker/agent";
import { getSelectType } from "@/api/public";
export default {
  name: "aging",
  components: {
    ChartLine,
  },
  props: {
    selData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      lineData: null,
      date: "",
      shipmentDate: "",
      oldDate: [],
      options: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        },
      },
      cod_type: "",
      country: "",
      countryList: [],
      transport_mode: "",
      transportList: [],
      client_id: "",
      chainOut: "",
      clientList: [],
      type: "",
      typeList: [],
      dateType: "",
      dateTypeList: [],
      DomesticList: [
        {
          value: "YES",
          label: "YES",
        },
        {
          value: "NO",
          label: "NO",
        },
      ],
      delivery_agent_id: "",
      deliveryList: [],
      headerType: "",
      headerList: [],
      customer_service_id: "",
      serviceList: [],
      dbl_customer_service_id: "",
      dblSerList: [],
      option: {
        title: {
          text: this.$t("analysis"),
          x: "center",
        },
        toolbox: {
          feature: {
            saveAsImage: {
              title: this.$t("download"),
            },
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [],
          bottom: 0,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [],
      },
    };
  },
  watch: {
    selData: {
      handler(val) {
        this.getSelData();
      },
      deep: true,
    },
  },
  methods: {
    // 发货量时间改变
    shipmentChangeDate(val) {
      let daystimestamp = 31 * 1000 * 24 * 3600;
      if (
        new Date(val[1]).getTime() - new Date(val[0]).getTime() >
          daystimestamp &&
        this.dateType == "day"
      ) {
        this.$Message["error"]({
          background: true,
          content: this.$t("time_not_31day"),
        });
        this.shipmentDate = this.oldDate;
        return;
      } else {
        this.shipmentDate = val;
        this.getAgingFun();
      }
    },
    // 筛选框改变
    selChange(val) {
      // this.getAgingFun();
    },
    // 获取下拉数据
    getSelData() {
      this.countryList = this.selData.countryList;
      this.transportList = this.selData.transportList;
      this.clientList = this.selData.clientList;
      this.typeList = this.selData.typeList;
      this.deliveryList = this.selData.deliveryList;
      this.headerList = this.selData.headerList;
      this.dateTypeList = this.selData.dateTypeList;
      this.serviceList = this.selData.serviceList;
      this.dblSerList = this.selData.dblSerList;
      if (this.typeList.length > 0) {
        this.type = this.typeList[0].value;
      }
      if (this.dateTypeList.length > 0) {
        this.dateType = this.dateTypeList[0].value;
      }
    },
    // 获取发货量数据
    getAgingFun() {
      if (!this.type) {
        this.type = this.selData.typeList.length
          ? this.selData.typeList[0].value
          : "";
      }
      let data = {
        startTime: format.customTime(this.shipmentDate[0], "YYYY-MM-DD"),
        endTime: format.customTime(this.shipmentDate[1], "YYYY-MM-DD"),
        cod_type: this.cod_type,
        country: this.country,
        client_id: this.client_id,
        type: this.type,
        dateType: this.dateType,
        transport_mode: this.transport_mode,
        delivery_agent_id: this.delivery_agent_id,
        headerType: this.headerType,
        chainOut: this.chainOut,
        customer_service_id: this.customer_service_id,
        dbl_customer_service_id: this.dbl_customer_service_id,
      };
      for (const key in data) {
        if (data[key] === "") {
          delete data[key];
        }
      }
      getHeadTime(data).then((res) => {
        if (res.data.status) {
          this.oldDate = this.shipmentDate;
          let lineData = res.data.payload;
          this.option.legend.data = [];
          this.option.xAxis.data = [];
          this.option.series = [];
          this.option.xAxis.data = lineData.report_date;
          this.option.title.text =
            lineData.report_date[0] +
            "~" +
            lineData.report_date[lineData.report_date.length - 1] +
            this.$t("analysis");
          if (lineData && lineData.rows && lineData.rows.length > 0) {
            lineData.rows.forEach((el) => {
              this.option.legend.data.push(el.country);
              this.option.series.push({
                name: el.country,
                type: "line",
                data: el.first_pass_time,
								label: {
									position: "top",
									show: true
								},
                markLine: {
                  data: [
                    {
                      yAxis: el.average ? el.average : 0, //平均值
                      name: "Avg",
                    },
                  ],
                },
              });
            });
          }
        }
      });
    },
  },
  mounted() {
    this.date = format.customTime(new Date(), "YYYY-MM");
    // console.log(getAssignDate(7), getAssignDate(0));

    this.shipmentDate = [getAssignDate(7), getAssignDate(0)];
    this.getAgingFun();
  },
};
</script>

<style lang="less">
.count-style {
  font-size: 50px;
}
</style>
